import { Component, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-run-list',
  templateUrl: './run-list.component.html',
  styleUrls: ['./run-list.component.css']
})
export class RunListComponent {

  constructor(private dataService: DataService,
  private router: Router,
  private messageService: MessageService){}

  @ViewChild('dt') dt: Table | undefined;

  runList: any[] = [];
  loading: boolean = true;
  selectedSample: any;
  cols: any[] = [];
  importingRuns: boolean = false;
  sendingData: boolean = false;
  sendingDataToOC: boolean = false;

  ngOnInit() {
    const filters = localStorage.getItem("filters");
    //this.runList.push({runId:123, runDate:Date.now(), name: "testrun123", openSamples:true, autoApproved:false})
    //this.loading = false;
    this.loadData();

    this.cols = [
      { field: 'processedDate', header: 'Run Date' },
      { field: 'name', header: 'Run Name' },
      { field: 'autoApproved', header: 'Auto Approved' },
      { field: 'sequencingMethod', header: 'Sequencing Method' }
    ];
  }

  clear(table: Table) {
    table.clear();
  }

  rowClick(record: any){
    //this.router.navigate(['detail',snpRecord.sampleId]);
  }

  viewRunDetail(record: any){
    this.router.navigate(['run-detail', {runId: record.runId}]);
  }
  viewSampleList(record: any){
    this.router.navigate(['sample-list', {runId: record.runId}]);
  }

  approve(record: any){
    this.sendingDataToOC = true;
    this.dataService.approveRun(record.runId)
      .then(data => {
        this.messageService.add({severity:'success', summary:'Approved open samples on ' + record.name + ' successfully.'});
        this.loadData();
      })
      .catch(error => {
        this.messageService.add({severity:'error', summary:'Open samples on run ' + record.name + ' could not be approved.'});
        this.sendingDataToOC = false;
      });
  }

  retest(record: any){
    this.loading = true;
    this.dataService.retestRun(record.runId)
      .then(data => {
        this.messageService.add({severity:'success', summary:'Retested open samples on ' + record.name + ' successfully.'});
        this.loadData();
      })
      .catch(error => {
        this.messageService.add({severity:'error', summary:'Open samples on run ' + record.name + ' could not be retested.'});
        this.loading = false;
      });

  }

  loadData(){
    this.dataService.getRunList().then(data => {
      this.runList = data;
      this.loading = false;
      this.sendingDataToOC = false;
      this.sendingData = false;
      this.importingRuns = false;
    });
  }


  sendRunToStorage(record: any){
    this.sendingData = true;
    this.dataService.sendRunToStorage(record.runId)
      .then(data => {
        this.messageService.add({severity:'success', summary:'Run ' + record.name + ' successfully sent to storage.'});
        this.loadData();
      })
      .catch(error => {
        this.messageService.add({severity:'error', summary:'Run ' + record.name + ' could not be sent to storage.'});
        this.sendingData = false;
      });
  }

  importRuns(){
    this.importingRuns = true;
    this.dataService.importRuns()
      .then(data => {
        this.messageService.add({severity:'success', summary:'Data imported successfully!'});
        this.loadData();
      })
      .catch(error => {
        this.messageService.add({severity:'error', summary:'Data could not be imported.'});
        this.importingRuns = false;
      });
  }
}
